<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    sideNav: false,
    version: process.env.VUE_APP_VERSION
  }),
  computed: {
    menuItems () {
      const menuItems = [
        { title: 'Register', link: '/register' },
        { title: 'Login', link: '/login' }
      ]
      return menuItems
    }
  },
  methods: {}
}
</script>
